const SELECTOR = ".animate-in-view, .animate-group";
const VISIBLE_CLASS = "is-in-view";

let observer = null;

function reveal(element) {
  element.classList.add(VISIBLE_CLASS);
  observer?.unobserve(element);
}

function getObserver() {
  if (observer) return observer;

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    },
    // negative bottom margin so an element is already inside the viewport before it reveals;
    // a positive one fires it off-screen and the reveal is over before it is ever seen
    { rootMargin: "0px 0px -10% 0px", threshold: 0 },
  );

  return observer;
}

function observe(root = document) {
  root.querySelectorAll(SELECTOR).forEach((element) => {
    if (element.classList.contains(VISIBLE_CLASS)) return;

    // The theme editor re-renders a section wherever it happens to sit, often outside the viewport,
    // where the observer would never fire and the content would stay invisible to whoever is
    // editing it. Everything is revealed outright there instead.
    if (window.Shopify?.designMode) {
      element.classList.add(VISIBLE_CLASS);
      return;
    }

    getObserver().observe(element);
  });
}

// Anything already on screen when this runs - a reload that restored the scroll position - would
// otherwise be revealed before the browser's first paint, so it never paints its hidden state and
// there is nothing for the transition to run from. Two frames guarantees that paint has happened.
requestAnimationFrame(() => requestAnimationFrame(() => observe()));

document.addEventListener("shopify:section:load", (event) =>
  observe(event.target),
);

document.addEventListener("shopify:section:reorder", () => observe());

window.observeAnimations = observe;
